import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "bg-primary-25 flex flex-col text-left justify-center px-4 text-gray-900 text-base font-medium",
    style: { "height": "52px" }
};
const _hoisted_2 = {
    style: { "height": "498px" },
    class: "overflow-y-scroll flex flex-col space-y-3 py-2"
};
const _hoisted_3 = { class: "flex flex-col space-y-2" };
const _hoisted_4 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_5 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_6 = { class: "flex flex-row items-center space-x-2" };
const _hoisted_7 = { class: "w-40 flex items-center" };
const _hoisted_8 = { class: "flex flex-col justify-start space-y-2 px-3 py-2" };
const _hoisted_9 = { class: "text-xs font-medium text-gray-700" };
const _hoisted_10 = { class: "flex flex-row space-x-6 px-3 border border-gray-300 rounded-lg items-center" };
const _hoisted_11 = { class: "text-md font-normal text-gray-400 px-4" };
const _hoisted_12 = { class: "flex flex-col items-center px-3 py-2 space-y-2" };
import UIStickerCollapse from '@/components/common/UIStickerCollapse.vue';
import { stickers } from '@/compositions/useStickersOptions';
import { computed, watch, ref, inject, onMounted, onUnmounted, } from 'vue';
import Konva from 'konva';
import { useHistoryStore } from '@/store/history';
import { HistoryType } from '@/types/history';
import { getHistoryObject } from '@/compositions/useHistoryHelper';
import { Tools } from '@/types/tools';
import { ShapeTypes } from '@/types/shapes';
import { Identifiers } from '@/types/identifiers';
import { UIDivider, UIColorPicker, UIInputNumber, UISlider, } from '@gohighlevel/ghl-ui';
import EmitterEvent from '@/events';
export default /*#__PURE__*/ _defineComponent({
    __name: 'StickersTool',
    props: {
        group: {
            type: Object,
            require: true,
        },
        stage: {
            type: Object,
            require: true,
        },
        selectedOption: {
            type: String,
            require: true,
        },
    },
    setup(__props) {
        const props = __props;
        let imageTransformer, elementControls;
        const scaleFactor = 0.1;
        const historyStore = useHistoryStore();
        const emitter = inject('emitter');
        const imageElement = ref([]);
        const activeNodeIndex = ref();
        const beforeObject = ref();
        const afterObject = ref(0);
        const stickerOpacity = ref(100);
        const stickerColor = ref('#EAECF0');
        const imageNode = ref();
        const imageHTMLElements = ref([]);
        const activeTool = computed(() => props.selectedOption);
        const isEmojiActive = computed(() => imageNode.value && imageNode.value instanceof Konva.Image);
        watch(activeTool, (newVal, oldVal) => {
            if (activeTool.value === Tools.STICKERS) {
                if (!imageTransformer) {
                    createTransformer();
                }
                addEventListeners();
            }
            else if (oldVal === Tools.STICKERS) {
                hideControls();
                handleOutsideClick();
                imageTransformer.detach();
                imageTransformer.hide();
                removeEventListeners();
            }
        });
        onMounted(() => {
            emitter.on(EmitterEvent.IMAGE_EDITOR_HISTORY_SET, setImageNode);
            emitter.on(EmitterEvent.IMAGE_EDITOR_CONTROLS_CLONE, cloneElement);
            emitter.on(EmitterEvent.IMAGE_EDITOR_CONTROLS_DELETE, deleteElement);
        });
        onUnmounted(() => {
            handleOutsideClick();
            // remove event listener from all text node
        });
        function setTransformer() {
            if (imageElement.value.length) {
                imageTransformer.detach();
                if (!imageNode.value)
                    imageNode.value = imageElement.value[activeNodeIndex.value];
                imageTransformer.nodes([imageNode.value]);
                imageTransformer.show();
                imageTransformer.forceUpdate();
                setControlPosition();
            }
        }
        function removeEventListeners() {
            if (imageElement.value.length) {
                imageElement.value.forEach(e => {
                    e.off('click transform mouseover mouseout dragmove transformend dragstart dragend');
                });
            }
        }
        function addEventListeners() {
            if (imageElement.value.length) {
                imageElement.value.forEach(e => {
                    setClickEvent(e);
                    setCursor(e);
                });
            }
        }
        function createTransformer() {
            imageTransformer = props.group.find(`#${Identifiers.STICKER_TRANSFORMER}`)[0];
            if (!imageTransformer) {
                imageTransformer = new Konva.Transformer({
                    enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                    // set minimum width of text
                    boundBoxFunc: function (oldBox, newBox) {
                        newBox.width = Math.max(30, newBox.width);
                        newBox.height = Math.max(30, newBox.height);
                        return newBox;
                    },
                    centeredScaling: true,
                    padding: 10,
                    id: Identifiers.STICKER_TRANSFORMER,
                    keepRatio: true,
                });
                props.group.add(imageTransformer);
                imageTransformer.hide();
            }
        }
        function setImageNode(history) {
            if (history && history.source === Tools.STICKERS) {
                if (props.selectedOption === Tools.STICKERS) {
                    setClickEvent(imageNode.value);
                }
                const elementIndex = imageElement.value.findIndex(image => image.id() === history.id);
                imageNode.value = props.group.find(`#${history.id}`)[0];
                if (elementIndex !== -1)
                    imageElement.value[elementIndex] = imageNode.value;
                else
                    imageElement.value.push(imageNode.value);
                if (props.selectedOption === Tools.STICKERS) {
                    setClickEvent(imageNode.value);
                    createTransformer();
                    setActiveNode(imageNode.value);
                }
            }
        }
        function setClickEvent(node) {
            if (node) {
                node.on('click', function (e) {
                    setActiveNode(e.target);
                });
                node.draggable(false);
            }
        }
        function setActiveEvents() {
            imageNode.value.off('click');
            imageNode.value.on('transform', function (e) {
                // reset scale, so only with is changing by transformer
                e.target.setAttrs({
                    width: imageNode.value.width() * imageNode.value.scaleX(),
                    height: imageNode.value.height() * imageNode.value.scaleY(),
                    scaleX: 1,
                    scaleY: 1,
                });
            });
        }
        function setActiveNode(node) {
            if (!node)
                return;
            setClickEvent(imageNode.value);
            imageNode.value = node;
            imageNode.value.draggable(true);
            setTransformer();
            setActiveEvents();
            setCursor(node);
            setToDefault();
        }
        function addShape(option) {
            setClickEvent(imageNode.value);
            activeNodeIndex.value = imageElement.value.length;
            setBeforeObject(HistoryType.REMOVE);
            imageNode.value = option.getNode(`${Identifiers.STICKER_ID_PREFIX}${activeNodeIndex.value}`, props.stage);
            props.group.add(imageNode.value);
            imageElement.value.push(imageNode.value);
            setTransformer();
            setActiveEvents();
            setCursor(imageNode.value);
            props.stage.batchDraw();
            setAfterObject(HistoryType.ADD, imageNode.value);
            setHistory(HistoryType.ADD);
            setToDefault();
        }
        function addImage(url) {
            try {
                const image = new Image();
                image.onload = () => {
                    setClickEvent(imageNode.value);
                    const stageWidth = props.stage.width();
                    const stageHeight = props.stage.height();
                    const newImageWidth = image.width * scaleFactor;
                    const newImageHeight = image.height * scaleFactor;
                    const left = Math.floor(stageWidth / 2) - Math.floor(newImageWidth / 2);
                    const top = Math.floor(stageHeight / 2) - Math.floor(newImageHeight / 2);
                    activeNodeIndex.value = imageElement.value.length;
                    setBeforeObject(HistoryType.REMOVE);
                    imageNode.value = new Konva.Image({
                        x: left,
                        y: top,
                        image: image,
                        width: newImageWidth,
                        height: newImageHeight,
                        align: 'center',
                        rotation: 0,
                        id: `${Identifiers.STICKER_ID_PREFIX}${activeNodeIndex.value}`,
                        draggable: true,
                        opacity: 1,
                    });
                    props.group.add(imageNode.value);
                    imageElement.value.push(imageNode.value);
                    imageHTMLElements.value.push({
                        id: `${Identifiers.STICKER_ID_PREFIX}${activeNodeIndex.value}`,
                        element: image,
                    });
                    setTransformer();
                    setActiveEvents();
                    setCursor(imageNode.value);
                    props.stage.batchDraw();
                    setAfterObject(HistoryType.ADD, imageNode.value, image);
                    setHistory(HistoryType.ADD);
                    setToDefault();
                };
                image.crossOrigin = 'Anonymous';
                image.src = url;
            }
            catch (error) {
                // console.log('error')
            }
        }
        function setCursor(node) {
            // Set initial cursor
            node.on('mouseover', function () {
                // document.body.classList.add('test-cursor')
                document.body.style.cursor = 'move';
            });
            node.on('mouseout', function () {
                document.body.style.cursor = 'default';
            });
            node.on('dragmove', function () {
                document.body.style.cursor = 'move';
                setControlPosition();
            });
            node.on('transform', function () {
                document.body.style.cursor = 'grabbing';
                setControlPosition();
                handleStarShape();
            });
            node.on('transformstart', function (e) {
                document.body.style.cursor = 'move';
                setBeforeObject(HistoryType.UPDATE, e.target);
            });
            node.on('transformend', function (e) {
                document.body.style.cursor = 'move';
                setAfterObject(HistoryType.UPDATE, e.target);
                setHistory(HistoryType.UPDATE);
            });
            node.on('dragstart', function (e) {
                setBeforeObject(HistoryType.UPDATE, e.target);
            });
            node.on('dragend', function (e) {
                setAfterObject(HistoryType.UPDATE, e.target);
                setHistory(HistoryType.UPDATE);
            });
        }
        function handleOutsideClick() {
            if (imageNode.value && imageTransformer) {
                imageTransformer.detach();
                setClickEvent(imageNode.value);
                imageNode.value = undefined;
            }
        }
        function setBeforeObject(type, node) {
            beforeObject.value = getHistoryObject(Tools.STICKERS, node, type);
        }
        function setAfterObject(type, node, blob) {
            afterObject.value = getHistoryObject(Tools.STICKERS, node, type, { blob });
        }
        function setHistory(type, id) {
            if (!id)
                id = imageNode.value.id();
            historyStore.setHistory(id, Tools.STICKERS, beforeObject.value, afterObject.value, type);
        }
        function opacityChange() {
            if (imageNode.value) {
                setBeforeObject(HistoryType.UPDATE, imageNode.value);
                imageNode.value.opacity(stickerOpacity.value / 100);
                setAfterObject(HistoryType.UPDATE, imageNode.value);
                setHistory(HistoryType.UPDATE);
            }
        }
        function handleColorChange() {
            if (imageNode.value && imageNode.value instanceof Konva.Image === false) {
                setBeforeObject(HistoryType.UPDATE, imageNode.value);
                imageNode.value.fill(stickerColor.value);
                setAfterObject(HistoryType.UPDATE, imageNode.value);
                setHistory(HistoryType.UPDATE);
            }
        }
        function setToDefault() {
            stickerOpacity.value = Math.trunc(imageNode.value.opacity() * 100);
            stickerColor.value = imageNode.value.fill() || '#EAECF0';
        }
        function cloneElement() {
            if (imageNode.value && props.selectedOption == Tools.STICKERS) {
                let blob;
                setBeforeObject(HistoryType.REMOVE);
                activeNodeIndex.value = imageElement.value.length;
                const cloneNode = imageNode.value.clone();
                cloneNode.id(`${Identifiers.STICKER_ID_PREFIX}${activeNodeIndex.value}`);
                cloneNode.setAttrs({
                    x: cloneNode.x() + 20,
                    y: cloneNode.y() + 20,
                });
                props.group.add(cloneNode);
                imageElement.value.push(cloneNode);
                cloneNode.off('click transform mouseover mouseout dragmove transformend dragstart dragend');
                setClickEvent(cloneNode);
                if (cloneNode instanceof Konva.Image) {
                    const imageElement = imageHTMLElements.value.find(image => image.id === imageNode.value.id());
                    if (imageElement) {
                        blob = imageElement.element;
                        imageHTMLElements.value.push({
                            id: cloneNode.id(),
                            element: blob,
                        });
                    }
                }
                else {
                    cloneNode.type = imageNode.value.type;
                }
                setAfterObject(HistoryType.ADD, cloneNode, blob);
                setHistory(HistoryType.ADD, `${Identifiers.STICKER_ID_PREFIX}${activeNodeIndex.value}`);
            }
        }
        function deleteElement() {
            if (imageNode.value && props.selectedOption == Tools.STICKERS) {
                setBeforeObject(HistoryType.ADD, imageNode.value);
                setAfterObject(HistoryType.REMOVE);
                setHistory(HistoryType.ADD);
                imageTransformer.detach();
                imageNode.value.destroy();
                imageNode.value = undefined;
                elementControls.style.display = 'none';
                elementControls.style.left = '0px';
                elementControls.style.top = '0px';
            }
        }
        function setControlPosition() {
            if (!elementControls)
                elementControls = document.getElementById('ghl-image-editor-element-control');
            elementControls.style.display = 'block';
            // at first lets find position of text node relative to the stage:
            const textPosition = imageNode.value.absolutePosition();
            const rotation = imageNode.value.rotation();
            let transform = '';
            if (rotation) {
                transform += 'rotateZ(' + rotation + 'deg)';
            }
            transform += 'translateY(-0px)';
            let offset = imageNode.value.width() * imageNode.value.scaleX(); // Distance from the rectangle center
            if (imageNode.value instanceof Konva.Image ||
                imageNode.value.type === ShapeTypes.SQUARE) {
                offset += 25;
            }
            else {
                const newOffset = offset - 25;
                if (newOffset >= imageNode.value.width()) {
                    offset = newOffset;
                }
            }
            const angle = (rotation * Math.PI) / 180; // Convert to radians
            const offsetX = offset * Math.cos(angle);
            const offsetY = offset * Math.sin(angle);
            // so position of textarea will be the sum of positions above:
            const areaPosition = {
                x: props.stage.container().offsetLeft + textPosition.x + offsetX,
                y: props.stage.container().offsetTop + textPosition.y + offsetY,
            };
            elementControls.style.top = areaPosition.y + 'px';
            elementControls.style.left = areaPosition.x + 'px';
            elementControls.style.transform = transform;
            elementControls.style.transformOrigin = 'left top';
        }
        function hideControls() {
            if (elementControls)
                elementControls.style.display = 'none';
        }
        function handleStarShape() {
            if (imageNode.value.type === ShapeTypes.STAR) {
                imageNode.value.innerRadius(imageNode.value.width() / 4);
                imageNode.value.outerRadius(imageNode.value.width() / 2);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('stickers.title')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('stickers.stickerOpacity')), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(UIInputNumber), {
                                    id: "media-editor-frame-opacity-input",
                                    size: "medium",
                                    value: stickerOpacity.value,
                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((stickerOpacity).value = $event)),
                                    style: { "width": "58px" },
                                    min: 0,
                                    max: 100,
                                    showButton: false,
                                    placeholder: "",
                                    disabled: !imageNode.value,
                                    onBlur: opacityChange
                                }, null, 8 /* PROPS */, ["value", "disabled"]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_unref(UISlider), {
                                        value: stickerOpacity.value,
                                        "onUpdate:value": [
                                            _cache[1] || (_cache[1] = ($event) => ((stickerOpacity).value = $event)),
                                            opacityChange
                                        ],
                                        step: 1,
                                        tooltip: false,
                                        min: 0,
                                        max: 100,
                                        disabled: !imageNode.value
                                    }, null, 8 /* PROPS */, ["value", "disabled"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('stickers.stickerColor')), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_unref(UIColorPicker), {
                                    compact: true,
                                    modes: ['hex'],
                                    defaultShow: false,
                                    defaultValue: stickerColor.value,
                                    value: stickerColor.value,
                                    "onUpdate:value": [
                                        _cache[2] || (_cache[2] = ($event) => ((stickerColor).value = $event)),
                                        handleColorChange
                                    ],
                                    disabled: !imageNode.value || _unref(isEmojiActive)
                                }, null, 8 /* PROPS */, ["defaultValue", "value", "disabled"]),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(stickerColor.value), 1 /* TEXT */)
                            ])
                        ]),
                        _createVNode(_unref(UIDivider)),
                        _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stickers), (sticker) => {
                                return (_openBlock(), _createBlock(UIStickerCollapse, {
                                    key: sticker.title,
                                    options: sticker.options,
                                    url: sticker.url,
                                    title: sticker.title,
                                    value: sticker.value,
                                    onSelectEmoji: addImage,
                                    onSelectShape: addShape
                                }, null, 8 /* PROPS */, ["options", "url", "title", "value"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ])
            ]));
        };
    }
});
